export const getStateSets = (state) => state.statesets.stateSets;

export const getStateSetsLoaded = (state) => state.statesets.siteLoaded;
